import React from 'react';
import { BalancingStatesMetricsV2 } from '../../components/BalancingStatesMetricsV2';

export const BalancingStatesMetricsPage: React.FC = () => {
  return <BalancingStatesMetricsV2 />;
};